import { z } from 'zod';

export const MagicLinkRequestSchema = z.object({
  email: z.string().email().max(254),
});
export type MagicLinkRequest = z.infer<typeof MagicLinkRequestSchema>;

export const MagicLinkVerifySchema = z.object({
  token: z.string().min(40).max(128),
});
export type MagicLinkVerify = z.infer<typeof MagicLinkVerifySchema>;

export const UserRoleSchema = z.enum(['admin', 'editor', 'viewer']);
export type UserRole = z.infer<typeof UserRoleSchema>;

export const SessionUserSchema = z.object({
  id: z.string().guid(),
  email: z.string().email(),
  /** Legacy combined name — preserved for older clients. */
  name: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  role: UserRoleSchema,
  organizationId: z.string().guid(),
});
export type SessionUser = z.infer<typeof SessionUserSchema>;

/** PATCH /auth/me — let the signed-in user edit their own profile. */
export const UpdateMeSchema = z.object({
  firstName: z.string().min(1).max(80).nullable().optional(),
  lastName: z.string().min(1).max(80).nullable().optional(),
  email: z.string().email().max(254).optional(),
});
export type UpdateMe = z.infer<typeof UpdateMeSchema>;

export const AuthSuccessSchema = z.object({
  accessToken: z.string(),
  user: SessionUserSchema,
});
export type AuthSuccess = z.infer<typeof AuthSuccessSchema>;
